// extracted by mini-css-extract-plugin
export default {"svg":"DynamicSVG_svg__MAWE9"};